import {useState, useEffect} from 'react';
import {Row, Col} from 'react-bootstrap'

const Footer = ({lang='ar', etat=''}) => {
    const local = lang==='ar' ? "ar-MA" : "en-US"
    const options = {hour12:false, weekday:'long'}
    const [time, Time] = useState("");

    const onTimer = () => {
        Time((new Date()).toLocaleTimeString(local, options))
    }

    return (
        <Row className="Footer">
            <Col sm={4} className="FooterEtat" >
            <p id="etat">{etat}</p>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://telegram.me/akademymabot"}><img src="https://akademy.ma/images/s-telegram.png" alt="telegram" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.linkedin.com/company/akademyma"}><img src="https://akademy.ma/images/linkedin.png" alt="linkedin" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/akademy.ma"}><img src="https://akademy.ma/images/facebook.png" alt="facebook" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/akademy.ma"}><img src="https://akademy.ma/images/instagram.png" alt="instagram" /></a>
            </Col>
            <Col  sm={3} className="FooterTime" onClick={onTimer} >
            <i><b>@ Akademy 2021 - </b>{time}</i>
            </Col>
        </Row>
    )
}

export default Footer;

/*
<script>
function showTime() {
    var d = new Date();
    document.getElementById("clock").innerHTML = d.toLocaleTimeString();
}
setInterval(showTime, 1000);
</script>
 
<p>Time: <span id="clock"></span></p>
*/

